import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/types/blockDefinition';
import type { ImageBlockStateType, ImageComponentType } from '@unifyapps/defs/blocks/Image/types';
import type { Action } from '@unifyapps/defs/types/action';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import Image from './Image';
import { imageGetCachableAssets } from './imageAssetExtractor';

class ImageBlockStateDefinition implements BlockStateDefinition {
  getBlockVersion() {
    return 0;
  }

  getComponent() {
    return Image;
  }

  get type(): ComponentTypeUnionType {
    return 'Image';
  }

  getBlockControlMethods() {
    return [
      {
        id: 'openInMediaViewer',
        label: 'Open In Media Viewer',
        method: (blockState: BlockStateUnionType | undefined, _: Action) => {
          return {
            ...blockState,
            state: {
              isOpenInMediaViewer: true,
            },
          } as ImageBlockStateType;
        },
      },
    ];
  }

  get initialStateGetter() {
    return (block: BlockType) => ({
      id: block.id,
      ..._pick(block.component as ImageComponentType, ['content', 'appearance', 'componentType']),
      state: {
        isOpenInMediaViewer: false,
      },
    });
  }

  getSlotOrder(_block: BlockType<ImageComponentType>): { order: string[] } {
    return {
      order: ['fallback'],
    };
  }

  getImplicitDependencyGroups() {
    return { isEntitySuspended: true };
  }

  // Delegates to the Node-importable sibling so the build-time
  // `cachableAssetExtractors` map can reach the same extractor without
  // loading this React-coupled class file.
  getCachableAssets(block: BlockType) {
    return imageGetCachableAssets(block);
  }
}

export default ImageBlockStateDefinition;
